<template>
  <div id="app">
    <TopBar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import TopBar from '@/components/common/TopBar.vue'
import Footer from '@/components/common/Footer.vue'

export default {
  name: 'App',
  components: {
    TopBar,
    Footer
  }
}
</script>
<style lang="less" src="./config/app-reset.less"></style>
<style lang="less" src="@/config/element-ui-reset.less"></style>
